import { Plus, RefreshCw, Building2, User, Moon, Sun } from 'lucide-preact';
import type { CommandAction } from '@/stores/commandPalette';
import { theme, toggleTheme } from '@/stores/theme';

export function buildQuickActions(): CommandAction[] {
  return [
    {
      id: 'action:create-lead',
      label: 'Crear lead',
      hint: 'Nuevo lead manual',
      icon: Plus,
      group: 'Acciones',
      keywords: ['nuevo', 'crear', 'lead', 'add'],
      perform: () => {
        history.pushState(null, '', '/leads?action=create');
        dispatchEvent(new PopStateEvent('popstate'));
      },
    },
    {
      id: 'action:sync',
      label: 'Lanzar sincronización',
      hint: 'Sync Meta + Shopify',
      icon: RefreshCw,
      group: 'Acciones',
      keywords: ['sync', 'sincronizar', 'meta', 'shopify', 'importar'],
      perform: () => {
        history.pushState(null, '', '/configuracion/integraciones');
        dispatchEvent(new PopStateEvent('popstate'));
      },
    },
    {
      id: 'action:switch-company',
      label: 'Cambiar empresa',
      hint: 'Cambiar de empresa activa',
      icon: Building2,
      group: 'Acciones',
      keywords: ['empresa', 'tenant', 'workspace', 'cambiar'],
      perform: () => {
        history.pushState(null, '', '/configuracion/empresas');
        dispatchEvent(new PopStateEvent('popstate'));
      },
    },
    {
      id: 'action:my-account',
      label: 'Mi cuenta',
      hint: 'Perfil y contraseña',
      icon: User,
      group: 'Acciones',
      keywords: ['cuenta', 'perfil', 'password', 'contraseña'],
      perform: () => {
        history.pushState(null, '', '/cuenta');
        dispatchEvent(new PopStateEvent('popstate'));
      },
    },
    {
      id: 'action:toggle-theme',
      label: 'Cambiar tema',
      hint: theme.value === 'dark' ? 'Cambiar a claro' : 'Cambiar a oscuro',
      icon: theme.value === 'dark' ? Sun : Moon,
      group: 'Acciones',
      keywords: ['tema', 'theme', 'dark', 'light', 'oscuro', 'claro'],
      perform: () => toggleTheme(),
    },
  ];
}
